import { render, staticRenderFns } from "./BoxBorder2.vue?vue&type=template&id=35df24b6&"
import script from "./BoxBorder2.vue?vue&type=script&lang=js&"
export * from "./BoxBorder2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports